export type ClientDetailTabKey =
  | 'balanceSheet'
  | 'accounts'
  | 'holdings'
  | 'gainsLosses'
  | 'investmentActivity'
  | 'cashFlow'
  | 'assetAllocation'
  | 'documents'
  | 'insights'
  | 'portalActivity';

export const DEFAULT_CLIENT_DETAIL_TAB: ClientDetailTabKey = 'balanceSheet';

export const CLIENT_DETAIL_TAB_KEYS: readonly ClientDetailTabKey[] = [
  'balanceSheet',
  'accounts',
  'holdings',
  'gainsLosses',
  'investmentActivity',
  'cashFlow',
  'assetAllocation',
  'documents',
  'insights',
  'portalActivity',
];

export function isClientDetailTabKey(
  value: string | null | undefined,
): value is ClientDetailTabKey {
  return CLIENT_DETAIL_TAB_KEYS.some((tabKey) => tabKey === value);
}

export function resolveClientDetailTab(
  value: string | null | undefined,
): ClientDetailTabKey {
  return isClientDetailTabKey(value) ? value : DEFAULT_CLIENT_DETAIL_TAB;
}
